import { SmartInterviewsBuilder } from '../smart-interviews.types';

export const deleteSmartInterview = (builder: SmartInterviewsBuilder) =>
  builder.mutation<void, number>({
    query: (id) => ({
      url: `/smart-interview-questions/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: () => [{ type: 'SmartInterviews' }],
  });
